import apiConfigPerfil from '../services/apiConfigPerfil'
import apiFollowUpByBoards from '../services/apiDeliveryFlowByBoard'

const state = {
  existPerfil: false,
  board: {},
  boards: [],
  totalBoards: '0',
  boardIndex: '0',
  countCards: {
    canceled: '0',
    cardsBacklog: '0',
    cardsDoing: '0',
    cardsDone: '0',
    cardsPaused: '0',
    notApplicable: '0'
  },
  countTasks: {
    backlogTasks: '0',
    doingTasks: '0',
    pausedTasks: '0',
    doneTasks: '0',
    totalTasks: '0'
  },
  countCompanys: {
    total: 0,
    doing: 0,
    done: 0
  },
  percentage: {
    backlogPercentage: 0,
    doingPercentage: 0,
    pausedPercentage: 0,
    donePercentage: 0
  },

  titleDepartamet: '',
  loopCount: 0
}

const getters = {
  board: (state) => state.board,
  boards: (state) => state.boards,
  countCards: () => state.countCards,
  countTasks: () => state.countTasks,
  countCompanys: () => state.countCompanys,
  percentage: () => state.percentage,
  titleDepartamet: () => state.titleDepartamet

}

const actions = {
  parseIntWithToLocaleString (value) {
    if (value > 0) {
      return value.toLocaleString('pt-BR')
    }
    return value
  },
  existPerfil ({ commit }) {
    apiConfigPerfil.existProfile()
      .then(payload => { commit('EXISTS_PROFILE', payload.data) })
      .catch(err => {
        this.$errorFormated(err.response)
        throw err
      })
  },

  async boardsByProfileId ({ commit }, profileId) {
    await apiFollowUpByBoards.getBoardsBy(profileId)
      .then(payload => {
        commit('SET_BOARDS', payload.data)
      })
      .catch(err => {
        this.$errorFormated(err.response)
        throw err
      })
  },
  setBoard ({ commit, getters }, indice) {
    commit('SET_BOARD', { boards: getters.boards, indice: indice })
  },

  async totalCards ({ commit, getters }, indice) {
    await apiFollowUpByBoards.getTotalCardsBy(getters.boards[indice].id)
      .then(payload => {
        commit('SET_TOTAL_CARDS', payload.data)
        commit('SET_PERCENTUAL_CARDS', payload.data)
      })
      .catch(err => {
        this.$errorFormated(err)
        throw err
      })
  },

  async totalTasks ({ commit, getters }, indice) {
    await apiFollowUpByBoards.getTotalTasksBy(getters.boards[indice].id)
      .then(payload => {
        commit('SET_TOTAL_TASKS', payload.data)
      })
      .catch(err => {
        this.$errorFormated(err.response)
        throw err
      })
  },

  async totalCompany ({ commit, getters }, indice) {
    await apiFollowUpByBoards.getTotalCompanyBy(getters.boards[indice].id).then(payload => {
      commit('SET_TOTAL_COMPANY', payload.data)
    })
      .catch(err => {
        this.$errorFormated(err.response)
        throw err
      })
  }

}

const mutations = {

  EXISTS_PROFILE (state, payload) {
    state.existPerfil = payload
  },
  SET_BOARDS (state, boards) {
    state.board = boards[0]
    state.boards = boards
  },
  SET_BOARD (state, { boards, indice }) {
    if (indice !== undefined) {
      state.board = boards[indice]
    }
  },
  SET_TOTAL_CARDS (state, payload) {
    state.countCards = {
      canceled: payload.canceled.toLocaleString('pt-BR'),
      cardsBacklog: payload.cardsBacklog.toLocaleString('pt-BR'),
      cardsDoing: payload.cardsDoing.toLocaleString('pt-BR'),
      cardsDone: payload.cardsDone.toLocaleString('pt-BR'),
      cardsPaused: payload.cardsPaused.toLocaleString('pt-BR'),
      notApplicable: payload.notApplicable.toLocaleString('pt-BR')
    }
  },
  SET_TOTAL_TASKS (state, payload) {
    state.countTasks = {
      backlogTasks: payload.backlogTasks.toLocaleString('pt-BR'),
      doingTasks: payload.doingTasks.toLocaleString('pt-BR'),
      pausedTasks: payload.pausedTasks.toLocaleString('pt-BR'),
      doneTasks: payload.doneTasks.toLocaleString('pt-BR'),
      totalTasks: payload.totalTasks.toLocaleString('pt-BR')
    }
  },
  SET_TOTAL_COMPANY (state, payload) {
    state.countCompanys = payload
  },

  SET_PERCENTUAL_CARDS (state, value) {
    let totalCards = value?.cardsBacklog + value?.cardsDoing + value?.cardsPaused + value?.cardsDone
    state.percentage = {
      backlogPercentage: value.cardsBacklog === 0 ? value.cardsBacklog : parseFloat((value.cardsBacklog * 100 / totalCards).toFixed(2)),
      doingPercentage: value.cardsDoing === 0 ? value?.cardsDoing : parseFloat((value?.cardsDoing * 100 / totalCards).toFixed(2)),
      pausedPercentage: value.cardsPaused === 0 ? value.cardsPaused : parseFloat((value?.cardsPaused * 100 / totalCards).toFixed(2)),
      donePercentage: value.cardsDone === 0 ? value.cardsDone : parseFloat((value?.cardsDone * 100 / totalCards).toFixed(2))
    }

    state.titleDepartamet = value.titleDepartamet
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
